import { useCallback, useMemo } from 'react';
import { useMytaverse } from '@providers/MytaverseProvider';
import { getHRData } from '@features/avaturn/helpers/hr';
import { useAvaturnHelperType } from '@features/avaturn/pages/Avaturn/interfaces';

import { env } from 'env';
import { IXRHrGenderTypes } from '@clients/ek/interfaces';
import { GenderType } from '@features/avaturn/interfaces';
import ParticipantsService from '@services/ParticipantsService';
import { AvatarTypes } from '@interfaces/avatar';
import AvaturnService from '@features/avaturn/services/AvaturnService';

const { REACT_APP_CLIENT_ENV } = env;

const getAvaturnBrand = (brand: string): string => {
  return REACT_APP_CLIENT_ENV === 'MYTAVERSE' ? brand : 'no-brand';
};

//TODO: remove all mentions about ixr
const useAvaturnHelper: useAvaturnHelperType = () => {
  const { user, configs } = useMytaverse();

  const hrData = useMemo(() => {
    return getHRData(user?.hrData);
  }, [user]);

  const getProcessedBrand = useCallback(
    () => getAvaturnBrand(hrData.brand),
    [hrData.brand],
  );

  const getGender = useCallback(() => {
    if (!hrData?.gender) {
      return;
    }
    return hrData?.gender?.toUpperCase() === IXRHrGenderTypes.F
      ? GenderType.FEMALE
      : GenderType.MALE;
  }, [hrData?.gender]);

  const getToken = useCallback(() => {
    return configs?.avaturn?.tokens?.mytaverse;
  }, [configs]);

  const getAssetParams = useCallback(() => {
    const { ixrCredentialStatus: credentialStatus, gender, brand } = hrData;
    return { credentialStatus, gender, brand };
  }, [hrData]);

  const getChangeAvatarParams = useCallback(() => {
    //TODO: should be implemented
    return null;
  }, [hrData]);

  const deleteAvatar = useCallback(async (avatarId: string, brand: string) => {
    return await ParticipantsService.deleteParticipantAvatarFromList({
      avatarType: AvatarTypes.AVATURN,
      avatarId,
      brand,
      hardDelete: true,
    });
  }, []);

  const exportPreprocess = useCallback(async (avaturnId: string) => {
    await AvaturnService.deleteAvaturn(avaturnId);
  }, []);

  return {
    getProcessedBrand,
    getGender,
    getToken,
    getAssetParams,
    getChangeAvatarParams,
    deleteAvatar,
    exportPreprocess,
  };
};

export default useAvaturnHelper;
